import { render, staticRenderFns } from "./RepasseFornecedorRead.vue?vue&type=template&id=3c7beef8&"
import script from "./RepasseFornecedorRead.vue?vue&type=script&lang=js&"
export * from "./RepasseFornecedorRead.vue?vue&type=script&lang=js&"
import style0 from "./RepasseFornecedorRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports